/* BATTLEFIELD */
export const GET_PRIORITY_ORDERS = 'GET_PRIORITY_ORDERS';
export const GET_PRIORITY_ORDERS_SUCCESS = 'GET_PRIORITY_ORDERS_SUCCESS';
export const GET_PRIORITY_ORDERS_FAIL = 'GET_PRIORITY_ORDERS_FAIL';

// ADD ORDER
export const ADD_PRIORITY_ORDER = 'ADD_PRIORITY_ORDER';
export const ADD_PRIORITY_ORDER_SUCCESS = 'ADD_PRIORITY_ORDER_SUCCESS';
export const ADD_PRIORITY_ORDER_FAIL = 'ADD_PRIORITY_ORDER_FAIL';

// UPDATE ORDER
export const UPDATE_PRIORITY_ORDER = 'UPDATE_PRIORITY_ORDER';
export const UPDATE_PRIORITY_ORDER_SUCCESS = 'UPDATE_PRIORITY_ORDER_SUCCESS';
export const UPDATE_PRIORITY_ORDER_FAIL = 'UPDATE_PRIORITY_ORDER_FAIL';

// DELETE ORDER
export const DELETE_PRIORITY_ORDER = 'DELETE_PRIORITY_ORDER';
export const DELETE_PRIORITY_ORDER_SUCCESS = 'DELETE_PRIORITY_ORDER_SUCCESS';
export const DELETE_PRIORITY_ORDER_FAIL = 'DELETE_PRIORITY_ORDER_FAIL';

// GET ARCHIVE ORDERS
export const GET_ACRHIVE_PRIORITY_ORDERS = 'GET_ACRHIVE_PRIORITY_ORDERS';
export const GET_ACRHIVE_PRIORITY_ORDERS_SUCCESS = 'GET_ACRHIVE_PRIORITY_ORDERS_SUCCESS';
export const GET_ACRHIVE_PRIORITY_ORDERS_FAIL = 'GET_ACRHIVE_PRIORITY_ORDERS_FAIL';

// GET SPECIFIC ORDERS
export const GET_SPEC_PRIORITY_ORDERS = 'GET_SPEC_PRIORITY_ORDERS';
export const GET_SPEC_PRIORITY_ORDERS_SUCCESS = 'GET_SPEC_PRIORITY_ORDERS_SUCCESS';
export const GET_SPEC_PRIORITY_ORDERS_FAIL = 'GET_SPEC_PRIORITY_ORDERS_FAIL';

// GET CHANGES HISTORY FOR SELECTED ORDER
export const GET_HISTORY = 'GET_HISTORY';
export const GET_HISTORY_SUCCESS = 'GET_HISTORY_SUCCESS';
export const GET_HISTORY_FAIL = 'GET_HISTORY_FAIL';

export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
